import '@websanova/vue-auth'

const Users = {
  namespaced: true,
  state: {
    oneUser: null,
    user: null,

    token_type: null,
    token_access_token: null,
    token_client: null,
    toekn_uid: null,
    toekn_expiry: null,
  },
  mutations: {
    getOneUser(state, data){
      state.user = data
    },
    setTokenData(state, token){
      state.token_type =          token? token.split(';')[0] : null
      state.token_access_token =  token? token.split(';')[1] : null
      state.token_client =        token? token.split(';')[2] : null
      state.toekn_uid =           token? token.split(';')[3] : null
      state.toekn_expiry =        token? token.split(';')[4] : null

      // if (token) localStorage.removeItem('default_auth_token')
    }
  },

  actions: {
    showOneUser(context, id){
      // context.commit('getOneUser', id)
    },
    setUser(context, data){
      context.commit('getOneUser', data)
      if (data) context.commit('setTokenData', localStorage.default_auth_token)
    },

  }
};

export default Users;